import React from 'react'

import Cross from 'assets/svgIconComponents/Cross'

const classes = {
  wrapper: 'Wizard-Header-wrapper',
  button: {
    wrapper: 'Wizard-Header-Button-wrapper',
  },
}

const Button = React.memo(props => {
  const { handler } = props
  return (
    <button className={classes.button.wrapper} type="button" onClick={handler}>
      <Cross />
    </button>
  )
})

Button.displayName = 'Button'

export const Header = React.memo(props => {
  const { onCloseHandler } = props
  return (
    <section className={classes.wrapper}>
      <Button handler={onCloseHandler} />
    </section>
  )
})

Header.displayName = 'Wizard-Header'

export default Header
